<section class="cf-card">
  <h2 class="cf-card__title">{{ section.label }}</h2>

  <div class="cf-card__body">
    <div class="cf-file-rejected" *ngIf="!isTypeAllowed">
      {{ TYPE_NOT_ALLOWED_MESSAGE }}
    </div>

    <app-files-card
      *ngIf="isTypeAllowed"
      [form]="form"
      [controlName]="controlName"
      [acceptExtensions]="acceptedExtensions"
      [acceptMimes]="cardAcceptMimes"
      [maxSizeBytes]="cardMaxSizeBytes"
      [maxFiles]="cardMaxFiles"
      [multiple]="allowMultiple"
      [required]="required"
      [readOnly]="readOnly"
      [submitted]="submitted"
      [labels]="cardLabels"
      [messages]="cardMessages"
      [persistAdded]="persistAdded"
      [persistRemoved]="persistRemoved"
    ></app-files-card>
  </div>
</section>
